import React from "react";
import Home from "../components/Home";

const PageHome = () => {
  return (
    <div className="bg-gray-100">
      <span>
        <Home />
      </span>
    </div>
  );
};
export default PageHome;
